/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * The loader styled components
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */

import styled, { keyframes } from 'styled-components';

import { colors } from '../../../../theme';

/*
* Loader Circle
*/

export const LoaderCircleStyled = styled.div`
    width: 24px;
    height: 24px;
    z-index: 5;
    border-radius: 50%;
    box-sizing: border-box;
    border: 2px solid transparent;
    border-top: 2px solid ${colors.loaderCircleColor};
    border-right: 2px solid ${colors.loaderCircleColor};
    animation: spin 2s linear infinite;
    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }
`;

/*
* Loader Linear
*/

const bigLoaderShimmer = keyframes`
    0% {
        background-position: -100px;
    }
    100% {
        background-position: 364px;
    }
`;

const LoaderLinearAnimation = styled.div`
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    backface-visibility: hidden;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-fill-mode: forwards;
    background: white;
    background: ${colors.loaderLinearBgColor};
`;

interface ILoaderLinearItemContainerStyled {
    maxWidth?: string;
}

export const LoaderLinearItemContainerStyled = styled.div.attrs({
    className: 'loader-linear__container',
})<ILoaderLinearItemContainerStyled>`
    position: relative;
    max-width: ${props => props.maxWidth ? props.maxWidth : '100%'};
    height: 12px;
`;

export const LoaderLinearItemLineStyled = styled(LoaderLinearAnimation)`
    width: 100%;
    animation-name: ${bigLoaderShimmer};
    animation-duration: 5s;
`;
